import { Button } from '@mui/material';
import MuiModal from '../../mui/MuiModal/MuiModal';

type UnsavedChangesModalProps = {
	open: boolean;
	onClose: () => void;
	onNavigate: () => void;
	onSave: () => void;
	isSaving?: boolean;
};

export const UnsavedChangesModal = ( {
	open,
	onClose,
	onNavigate,
	onSave,
	isSaving,
}: UnsavedChangesModalProps ) => (
	<MuiModal
		muiModalProps={ { open, onClose } }
		title='Unsaved changes'
		description='You have unsaved changes that will be lost if you navigate away.'
		controls={
			<>
				<Button onClick={ onNavigate } color='secondary'>
					Leave page
				</Button>
				<Button color='primary' onClick={ onSave } loading={ isSaving }>
					Save
				</Button>
			</>
		}
	/>
);
